"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMissingDataForSelectedUnit = exports.isSelectedFuelTrad = exports.getCompareOptions = exports.isNextDateAvailable = exports.isPreviousDateAvailable = exports.isYesterdayAvailable = exports.isLastMonthAvailable = exports.isLastYearAvailable = exports.getUnitOptions = exports.getFuelOptions = exports.getDefaultUnit = exports.getDefaultFuel = exports.getNextDateForPeriod = exports.getPreviousDateForPeriod = exports.formatDateForPeriod = void 0;
var date_fns_1 = require("date-fns");
var core_1 = require("../../../../shared/core");
var utils_1 = require("../../utils");
var formatDateForPeriod = function (date, datePeriod) {
    switch (datePeriod) {
        case 'yearly':
            return (0, date_fns_1.format)(date, 'yyyy');
        case 'monthly':
            return (0, date_fns_1.format)(date, 'MMM yyyy');
        default:
            return (0, date_fns_1.format)(date, 'd MMM yyyy');
    }
};
exports.formatDateForPeriod = formatDateForPeriod;
var getPreviousDateForPeriod = function (datePeriod, date, supplyStartDate) {
    var newDate;
    switch (datePeriod) {
        case 'yearly':
            newDate = (0, date_fns_1.startOfYear)((0, date_fns_1.subYears)(date, 1));
            break;
        case 'monthly':
            newDate = (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(date, 1));
            break;
        default:
            newDate = (0, date_fns_1.subDays)(date, 1);
    }
    return supplyStartDate && (0, date_fns_1.isBefore)(newDate, supplyStartDate)
        ? supplyStartDate
        : newDate;
};
exports.getPreviousDateForPeriod = getPreviousDateForPeriod;
var getNextDateForPeriod = function (datePeriod, date) {
    switch (datePeriod) {
        case 'yearly':
            return (0, date_fns_1.startOfYear)((0, date_fns_1.addYears)(date, 1));
        case 'monthly':
            return (0, date_fns_1.startOfMonth)((0, date_fns_1.addMonths)(date, 1));
        default:
            return (0, date_fns_1.addDays)(date, 1);
    }
};
exports.getNextDateForPeriod = getNextDateForPeriod;
var getDefaultFuel = function (search, _a) {
    var electricity = _a.electricity, gas = _a.gas;
    var fromQuery = (0, core_1.getValueFromQueryParams)('fuel', search);
    var defaultFuel = gas && electricity ? 'both' : electricity ? 'electricity' : 'gas';
    return fromQuery === 'both' && electricity && gas
        ? 'both'
        : fromQuery === 'electricity' && electricity
            ? 'electricity'
            : fromQuery === 'gas' && gas
                ? 'gas'
                : defaultFuel;
};
exports.getDefaultFuel = getDefaultFuel;
var getDefaultUnit = function (search) {
    var result = (0, core_1.getValueFromQueryParams)('unit', search) ||
        // UsageUnit is legacy, remove later.
        (0, core_1.getValueFromQueryParams)('usageUnit', search);
    if (result === 'pounds' || result === 'kwh') {
        return result;
    }
    return 'kwh';
};
exports.getDefaultUnit = getDefaultUnit;
var getFuelOptions = function (_a) {
    var electricity = _a.electricity, gas = _a.gas;
    var options = [];
    if (electricity) {
        options.push('electricity');
    }
    if (gas) {
        options.push('gas');
    }
    if (electricity && gas) {
        options.push('both');
    }
    return options;
};
exports.getFuelOptions = getFuelOptions;
var getUnitOptions = function (datePeriod) {
    var options = ['kwh'];
    switch (datePeriod) {
        case 'monthly':
        case 'yearly':
            options.push('pounds');
    }
    return options;
};
exports.getUnitOptions = getUnitOptions;
var isLastYearAvailable = function (date, supplyStartDate, datePeriod) {
    if (datePeriod === 'yearly') {
        return (0, date_fns_1.differenceInYears)(date, (0, date_fns_1.startOfYear)(supplyStartDate)) >= 1;
    }
    return (0, date_fns_1.differenceInYears)(date, supplyStartDate) >= 1;
};
exports.isLastYearAvailable = isLastYearAvailable;
var isLastMonthAvailable = function (date, supplyStartDate) {
    return (0, date_fns_1.differenceInMonths)(date, (0, date_fns_1.startOfMonth)(supplyStartDate)) >= 1;
};
exports.isLastMonthAvailable = isLastMonthAvailable;
var isYesterdayAvailable = function (date, supplyStartDate) {
    return (0, date_fns_1.differenceInDays)(date, supplyStartDate) >= 1;
};
exports.isYesterdayAvailable = isYesterdayAvailable;
var isPreviousDateAvailable = function (datePeriod, date, supplyStartDate) {
    switch (datePeriod) {
        case 'monthly':
            return (0, exports.isLastMonthAvailable)(date, supplyStartDate);
        case 'yearly':
            return (0, exports.isLastYearAvailable)(date, supplyStartDate, 'yearly');
        default:
            return (0, exports.isYesterdayAvailable)(date, supplyStartDate);
    }
};
exports.isPreviousDateAvailable = isPreviousDateAvailable;
var isNextDateAvailable = function (datePeriod, date) {
    var next = (0, exports.getNextDateForPeriod)(datePeriod, date);
    return !(0, date_fns_1.isFuture)(next) && !(0, date_fns_1.isToday)(next);
};
exports.isNextDateAvailable = isNextDateAvailable;
var getCompareOptions = function (datePeriod, date, supplyInfo) {
    var options = [];
    var supplyStartDate = (0, utils_1.getEarliestSupplyStartDate)(supplyInfo);
    var lastYearAvailable = supplyStartDate
        ? (0, exports.isLastYearAvailable)(date, supplyStartDate, datePeriod)
        : false;
    var lastMonthAvailable = supplyStartDate
        ? (0, exports.isLastMonthAvailable)(date, supplyStartDate)
        : false;
    switch (datePeriod) {
        case 'monthly':
            if (lastMonthAvailable) {
                options.push('oneMonthEarlier');
            }
            if (lastYearAvailable) {
                options.push('sameMonthLastYear');
            }
            break;
        case 'yearly':
            if (lastYearAvailable) {
                options.push('previousYear');
            }
    }
    return options;
};
exports.getCompareOptions = getCompareOptions;
var isSelectedFuelTrad = function (fuel, supplyInfo) {
    switch (fuel) {
        case 'both':
            return (0, utils_1.hasTradMeter)(supplyInfo);
        case 'electricity':
            return (supplyInfo.electricity && supplyInfo.electricity.type === 'traditional');
        case 'gas':
            return supplyInfo.gas && supplyInfo.gas.type === 'traditional';
    }
};
exports.isSelectedFuelTrad = isSelectedFuelTrad;
var isMissingDataForSelectedUnit = function (data, fuel, unit) {
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    var hasElec = data.some(function (item) { return item.current.electricity && item.current.electricity[unitProp]; });
    var hasGas = data.some(function (item) { return item.current.gas && item.current.gas[unitProp]; });
    switch (fuel) {
        case 'both':
            return !hasElec && !hasGas;
        case 'electricity':
            return !hasElec;
        case 'gas':
            return !hasGas;
    }
};
exports.isMissingDataForSelectedUnit = isMissingDataForSelectedUnit;
